import { Button } from '@vrplatform/components';
import { useLegacyColors } from '@vrplatform/theme';
import { Stack, Text } from '@mantine/core';
import { ConfirmModalResultIcon } from '../_components';
import { Icon } from '@vrplatform/icons';

type ErrorScreenProps = {
  resultMessage: string;
  onClose: () => void;
  onSubmit: () => void;
};

export const ErrorScreen = ({
  resultMessage,
  onClose,
  onSubmit,
}: ErrorScreenProps) => {
  const { gray } = useLegacyColors();

  return (
    <>
      <Stack gap={0} mb="lg" align="center" justify="center" sx={{ flex: 1 }}>
        <ConfirmModalResultIcon color="#FFEEEE">
          <Icon icon={'AlertTriangleIcon'} color="#FF5656" size={48} />
        </ConfirmModalResultIcon>
        <Text fw={500} mb={10} sx={{ textAlign: 'center' }}>
          {resultMessage}
        </Text>
      </Stack>

      <Button
        variant="primary"
        onClick={onSubmit}
        sx={{ width: '100%', height: 40, marginBottom: 10 }}
      >
        Retry
      </Button>
      <Button onClick={onClose} sx={{ width: '100%', color: gray.dark }}>
        Cancel
      </Button>
    </>
  );
};
